import { ThemeConfig } from 'antd';

import tokens from './tokens';
import palette from '../default/palette';

const components = {
  Tag: {
    borderRadius: 4,
    colorBorder: palette.gray[0]
  },
  Drawer: {
    colorBgBase: palette.gray[11]
  },
  Radio: {
    colorPrimary: palette.brand.primary,
    colorBorder: palette.gray[0],
    colorBgContainer: palette.gray[0]
  },
  Select: {
    colorIcon: palette.alpha(palette.gray[0], 0.45),
    colorBorder: palette.gray[8],
    colorText: tokens?.colorText,
    colorBgContainer: palette.gray[9],
    lineWidth: 0
  },
  Button: {
    colorBorder: palette.gray[0],
    fontSize: 16,
    fontSizeLG: 16,
    fontWeightStrong: 500,
    colorTextLightSolid: palette.gray[12]
  },
  Dropdown: {
    colorBgElevated: palette.gray[11],
    colorText: palette.gray[0],
    fontSize: 16,
    fontSizeIcon: 16,
    fontSizeSM: 16
  },
  Divider: {
    colorSplit: palette.alpha(palette.gray[0], 0.45)
  },
  Typography: {
    colorLinkHover: palette.alpha(palette.gray[0], 0.45),
    colorLinkActive: palette.alpha(palette.gray[0], 0.25),
    colorLink: palette.gray[0]
  },
  Input: {
    colorText: tokens?.colorText,
    colorBgContainer: palette.gray[9],
    colorBorder: palette.gray[8],
    fontSizeLG: 16
  },
  Tabs: {
    fontSizeTabActive: 20,
    fontSizeLG: 18,
    fontSizeSM: 16,
    colorText: palette.gray[0]
  },
  Result: {
    colorText: palette.gray[0]
  },
  Checkbox: {
    colorBorder: palette.gray[8],
    colorBgContainer: palette.gray[10]
  },
  Timeline: {
    colorSplit: palette.gray[8],
    lineWidthBold: 1
  },
  Modal: {
    colorBgBase: palette.gray[1],
    colorBgContainer: palette.gray[1],
    colorBgElevated: palette.gray[9]
  },
  Skeleton: {
    color: palette.gray[8]
  }
} as ThemeConfig['components'];

export default components;
